/** @jsx jsx */
import { useEffect,  useMemo } from "react"
import { css, jsx } from '@emotion/react'
import { useStaticQuery, graphql } from "gatsby"
import styled from '@emotion/styled';
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import SectionHeadline from '../../../components/SectionHeadline'
import CardList from '../../../components/CardList'
import RoundButton from '../../../components/RoundButton';
import { useLocalization } from 'gatsby-theme-i18n';
import * as breakpoint from '../../../styles/breakpoints.module.scss';
import AnimatedSection from '../../../components/AnimatedSection';
import { DateTime } from 'luxon';

const DigitalActivitiesSection = (props) => {

  const { t, addString, localeKey, currentLocaleObj } = useLocalization();

  const data = useStaticQuery(graphql`
  query DigitalActivities {
    background : file(sourceInstanceName: {eq: "images"}, relativePath: {eq: "layout/bg_digitalActivity.jpg"}) {
      childImageSharp {
        gatsbyImageData(
          layout: FULL_WIDTH
          placeholder: NONE
        )
      }
    }

    activitiesList : allActivities(
      sort: {fields: order}, 
      filter: {
        data: {
          pickup: {eq: "true"}, 
          status: {eq: "publish"}
        }
      }) {
      edges {
        node {
          title {
            ...localizedContent
          }
          data{
            ...localizedContent
            order
            update_date
            status
            anchor
          }
          desc {
            ...localizedContent
          }
          outbound_url {
            ...localizedContent
          }
          inbound_url
          thumb {
            childImageSharp {
              gatsbyImageData(
                layout: FULL_WIDTH
                placeholder: NONE
              )
            }
          }
        }
      }
    }




    allActivityCsv {
      nodes {
        ...localizedContent
      }
    }


   

  }
`);

const activitiesList = useMemo(() => {
  if(data.activitiesList)
  {
    let list = [];
     data.activitiesList.edges.forEach((item) => {
      if(item.node.data[localeKey] === "true")
      list.push({
        category: '',
        title: item.node.title[localeKey],
        desc: item.node.desc[localeKey],
        image: getImage(item.node.thumb),
        isNew:  DateTime.fromISO(item.node.data.update_date).diff(DateTime.local(), [ 'days']).values.days > -3,
        outbound_url: item.node.outbound_url ? item.node.outbound_url[localeKey] : null,
        inbound_url: item.node.inbound_url ? `/${currentLocaleObj.prefix}${item.node.inbound_url}` : null,
        anchor: item.node.data.anchor
      });
    });

    return list;
  } else {
    return [];
  }
},[data,localeKey,currentLocaleObj.prefix]);

useEffect(() => {
  addString('activity',data.allActivityCsv.nodes);
},[addString,data]);

  return (
    <SectionWrapper id="section_digitalActivity">
      <AnimatedSection>
        <Content>
          <SectionHeadline title={t('activity.activity.title')} subtitle={t('activity.activity.subtitle')} color={'#43A047'} icon={'GoldSaucer'} />
          <CardList colNum={3} list={activitiesList} isFull={"true"} />
          <ButtonContainer>
            <RoundButton color={"#F50057"} size={"large"} fixedwidth="true" fade to={`/${currentLocaleObj.prefix}/activity/`} css={css`
              width:448px;
              font-size: 28px;
              line-height: 32px;
              padding-top:16px;
              padding-bottom:16px; 
              height: auto;
              border-radius: 48px;

              @media only screen and (max-width: ${breakpoint.smMax}){
                width:288px;
                font-size: 17px;
                line-height: 24px;
                height:auto;
                padding:12px 24px;
              }

              @media only screen and (max-width: ${breakpoint.xsMax}){
                font-size: 14px;
                line-height: 20px;
                
                padding-top:8px;
                padding-bottom:8px; 
                width: 100%;
                border-radius: 32px;
              }

            `}>
              {t('home.activity.button.label')}
            </RoundButton>
          </ButtonContainer>
        </Content>
      </AnimatedSection>
      <Background><GatsbyImage image={getImage(data.background)} alt={"background"} /></Background>
    </SectionWrapper>
  );
};


export default DigitalActivitiesSection;

const SectionWrapper = styled.div`
  background:#F7F7FA;
  min-height:896px;
  position:relative;
  padding:96px 0;
  
  @media only screen and (max-width: ${breakpoint.smMax}){
    padding:64px 0;
    min-height:0;
  }
  @media only screen and (max-width: ${breakpoint.xsMax}){
    min-height:0;
    padding:32px 0;
  }
  
`;
const Content = styled.div`
  width:100%;
  margin:0 auto;
  position:relative;
  border-radius: 4px;
  overflow:hidden;
  z-index:5;
  max-width: calc(1440px + 96px);

  @media only screen and (max-width: ${breakpoint.smMax}){
    .sectionHeadline{
      padding:0 80px;
    }
  }
  @media only screen and (max-width: ${breakpoint.xsMax}){
    .sectionHeadline{
      padding:0 24px;
    }
  }
`

const Background = styled.div`
  width:615px;
  height:auto;
  position:absolute;
  top:0;
  right:0;
  z-index:1;

  @media only screen and (max-width: ${breakpoint.smMax}){
    width:384px;
  }
  @media only screen and (max-width: ${breakpoint.xsMax}){
    display:none;
  }
`

const ButtonContainer = styled.div`
  text-align:center;

  padding:0;

  @media only screen and (max-width: ${breakpoint.smMax}){
    padding:0px 80px;
  }
  @media only screen and (max-width: ${breakpoint.xsMax}){
    padding:0px 24px;
  }
`
